<template>
  <i-modal
    dontSave
    :load="load"
    :max-width="'1200px'"
    :title="$tc('history_customer', 2)"
    :value="value"
    @input="$emit('input', $event)"
  >
    <v-card-text>
      <v-tabs centered color="primary" v-model="mode">
        <v-tab v-if="checkPermissions.viewReceivables" href="#receivable">
          <v-icon class="mr-1" small dark>fas fa-file-invoice</v-icon>
          {{ $t('receivable') }}
        </v-tab>
        <v-tab v-if="checkPermissions.viewProducts" href="#product">
          <v-icon class="mr-1" small dark>fa-shopping-cart</v-icon>
          {{ $t('history_product') }}
        </v-tab>
      </v-tabs>
      <v-tabs-items class="py-5" v-model="mode">
        <!-- Cuentas por cobrar -->
        <v-tab-item v-if="checkPermissions.viewReceivables" value="receivable">
          <v-data-table
            :headers="receivableHeaders"
            :items="receivable"
            item-key="pk"
          >
            <template v-slot:item.balance="{ value }">
              <i-money :value="value" mode="text" />
            </template>
            <template v-slot:item.date_init="{ value }">
              {{ dateFormat(value) }}
            </template>
            <template v-slot:item.date_end="{ value }">
              {{ dateFormat(value) }}
            </template>
            <template v-slot:item.state="{ value }">
              {{ value === 'paid' ? $tc(value, 0) : $t(value) }}
            </template>
          </v-data-table>
        </v-tab-item>

        <!-- Subórdenes -->
        <v-tab-item v-if="checkPermissions.viewProducts" value="product">
          <v-data-table
            :headers="subordersHeaders"
            :items="product"
            item-key="pk"
          >
            <template v-slot:item.price="{ value }">
              <i-money :value="value" mode="text" />
            </template>
            <template v-slot:item.total="{ value }">
              <i-money :value="value" mode="text" />
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </i-modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    }
  },
  data() {
    return {
      type: 'customer',
      dialog: false,
      load: false,
      invoice: [],
      receivable: [],
      product: [],
      pk: null,
      mode: 'receivable'
    }
  },
  methods: {
    async getValues() {
      this.load = true
      try {
        let response = await this.$api.customer.history({
          pk: this.pk,
          opt: { params: { mode: this.mode } }
        })
        this[this.mode] = response.data
      } catch (error) {
        console.error(error)
      } finally {
        this.load = false
      }
    }
  },
  watch: {
    mode: {
      handler() {
        this.getValues()
      }
    },
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = this.toEdit !== null
          this.pk = this.toEdit.pk
          this.getValues()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @return {boolean}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        viewReceivables: this.getPermissions([`invoices.view_receivable`]),
        viewProducts: this.getPermissions([`product.view_product`])
      }
    },
    receivableHeaders() {
      return [
        {
          text: this.$t('number_control'),
          value: 'code'
        },
        {
          text: this.$tc('start_date'),
          value: 'date_init'
        },
        {
          text: this.$t('end_date'),
          value: 'date_end'
        },
        {
          text: this.$t('balance'),
          value: 'balance',
          align: 'right'
        },
        {
          text: this.$t('status'),
          value: 'state'
        }
      ]
    },
    subordersHeaders() {
      return [
        {
          text: this.$tc('suborder', 1),
          value: 'name'
        },
        {
          text: this.$t('product_code'),
          value: 'product__internalCode'
        },
        {
          text: this.$tc('product', 1),
          value: 'product__name'
        },
        {
          text: this.$tc('quantity', 1),
          value: 'quantity',
          align: 'right'
        },
        {
          text: this.$tc('price', 1),
          value: 'price',
          align: 'right'
        },
        {
          text: this.$tc('total', 1),
          value: 'total',
          align: 'right'
        }
      ]
    }
  }
}
</script>
